import React, { useState, useEffect } from 'react';
import './Overview.css';

const WHAT_WE_DO = [
  {
    num: '01',
    title: 'Program Development & Management',
    desc: 'Industry-aligned curriculum design, academic structuring, and operational execution for high-quality program delivery.',
  },
  {
    num: '02',
    title: 'Student Admissions & Outreach',
    desc: 'Strategic outreach, counselling, and admissions support to connect the right students with the right programs.',
  },
  {
    num: '03',
    title: 'Industry Internships',
    desc: 'Real-world internship opportunities that bridge academic learning with hands-on professional experience.',
  },
  {
    num: '04',
    title: 'Career Development & Placements',
    desc: 'Career guidance, skill development, industry interactions, and placement opportunities with leading organizations.',
  },
];

const PROGRAMS = [
  {
    label: 'School of Engineering & Technology',
    title: 'Engineering & Technology',
    courses: [
      { course: 'B.Tech CE', duration: '4 Years' },
      { course: 'B.Tech CSE', duration: '4 Years' },
      { course: 'B.Tech CSE (AI)', duration: '4 Years', badge: 'Minor Degree with IIT Mandi' },
      { course: 'B.Tech EE', duration: '4 Years' },
      { course: 'B.Tech ME', duration: '4 Years' },
    ],
  },
  {
    label: 'School of Computer Science',
    title: 'Computer Science',
    courses: [
      { course: 'BCA (AI)', duration: '3 Years', badge: 'Minor Degree with IIT Mandi' },
      { course: 'BCA', duration: '3 Years' },
      { course: 'MCA', duration: '2 Years' },
    ],
  },
  {
    label: 'School of Pharmaceutical Sciences',
    title: 'Pharmaceutical Sciences',
    courses: [
      { course: 'B.Pharm', duration: '4 Years' },
      { course: 'D.Pharm', duration: '2 Years' },
      { course: 'M.Pharm (Pharmaceutics)', duration: '2 Years' },
      { course: 'M.Pharm (Pharmaceutical Chemistry)', duration: '2 Years' },
    ],
  },
  {
    label: 'School of Commerce & Management',
    title: 'Commerce & Management',
    courses: [
      { course: 'B.Com', duration: '3 Years' },
      { course: 'B.Com (Hons.)', duration: '4 Years' },
      { course: 'BBA', duration: '3 Years' },
      { course: 'BBA (Hons.)', duration: '4 Years' },
      { course: 'MBA', duration: '2 Years' },
    ],
  },
  {
    label: 'School of Agriculture Science',
    title: 'Agriculture Science',
    courses: [
      { course: 'B.Sc (Hons.) Agriculture Science', duration: '4 Years' },
      { course: 'Diploma Agriculture', duration: '2 Years' },
      { course: 'M.Sc Agriculture', duration: '2 Years' },
      { course: 'Soil Science / Entomology / Plant Pathology', duration: '2 Years' },
    ],
  },
  {
    label: 'School of Law',
    title: 'Law',
    courses: [
      { course: 'BA LLB (Hons.)', duration: '5 Years' },
      { course: 'BBA LLB (Hons.)', duration: '5 Years' },
      { course: 'LLB', duration: '3 Years' },
      { course: 'LLM', duration: '2 Years' },
    ],
  },
  {
    label: 'School of Humanities',
    title: 'Humanities',
    courses: [
      { course: 'BA / BA (Hons.)', duration: '3 Years' },
      { course: 'MA (English / Political Science / Economics / Psychology)', duration: '2 Years' },
    ],
  },
  {
    label: 'School of Physical Sciences',
    title: 'Physical Sciences',
    courses: [
      { course: 'B.Sc (Medical / Non-Medical)', duration: '3 Years' },
      { course: 'M.Sc (Physics / Chemistry / Mathematics)', duration: '2 Years' },
    ],
  },
  {
    label: 'School of Life Sciences',
    title: 'Life Sciences',
    courses: [
      { course: 'B.Sc (Medical)', duration: '3 Years' },
      { course: 'B.Sc (Non-Medical)', duration: '3 Years' },
      { course: 'Botany / Zoology', duration: '3 Years' },
    ],
  },
  {
    label: 'School of Paramedical Sciences',
    title: 'Paramedical Sciences',
    courses: [
      { course: 'Bachelor of Physiotherapy (BPT)', duration: '4 Years' },
      { course: 'B.Sc Operation Theatre Technology (OTT)', duration: '3 Years' },
      { course: 'B.Sc Radiology & Imaging Technology (RIT)', duration: '3 Years' },
      { course: 'B.Sc Medical Laboratory Technology (MLT)', duration: '3 Years' },
      { course: 'B.Sc Dialysis', duration: '3 Years' },
      { course: 'B.Sc Anaesthesia', duration: '3 Years' },
      { course: 'M.Sc Microbiology', duration: '2 Years' },
    ],
  },
  {
    label: 'School of Hotel Management',
    title: 'Hotel Management',
    courses: [
      { course: 'BHM', duration: '4 Years' },
      { course: 'Master of Hotel Management & Catering Technology', duration: '2 Years' },
    ],
  },
  {
    label: 'School of Polytechnic',
    title: 'Polytechnic',
    courses: [
      { course: 'Diploma in Civil Engineering', duration: '3 Years' },
      { course: 'Diploma in Mechanical Engineering', duration: '3 Years' },
      { course: 'Diploma in Electrical Engineering', duration: '3 Years' },
      { course: 'Diploma in Computer Science Engineering', duration: '3 Years' },
      { course: 'Diploma in Electronics & Communication', duration: '3 Years' },
      { course: 'Diploma in Automobile Engineering', duration: '3 Years' },
      { course: 'Diploma in Fashion Designing', duration: '3 Years' },
      { course: 'Diploma in Architecture Assistantship', duration: '3 Years' },
    ],
  },
  {
    label: 'School of Allied Health Science',
    title: 'Allied Health Science',
    courses: [
      { course: 'B.Sc Allied Health Sciences (GN) / Medical Technology', duration: '3 Years' },
      { course: 'B.Sc Medical Laboratory Technology (BMLT)', duration: '3 Years' },
      { course: 'B.Sc Operation Theatre Technology (OTT)', duration: '3 Years' },
    ],
  },
];

const ProgramModal = ({ program, onClose, onApplyNow }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handleKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKey);
    };
  }, [onClose]);

  const handleApply = () => {
    onClose();
    onApplyNow(`Hi CampusXL, I would like to know more about the ${program.title} programs you offer. Shall I get a call from your side?\nThanks.`);
  };

  return (
    <div className="pm-overlay" onClick={onClose}>
      <div className="pm-container" onClick={(e) => e.stopPropagation()}>
        <div className="pm-header">
          <div>
            <p className="pm-eyebrow">Academic Program</p>
            <h2 className="pm-title">{program.label}</h2>
            <p className="pm-subtitle">Programs & courses CampusXL offers — built for the careers of tomorrow.</p>
          </div>
          <button className="pm-close" onClick={onClose} aria-label="Close">✕</button>
        </div>
        <div className="pm-body">
          <table className="pm-table" style={{ marginBottom: '0.5rem' }}>
            <thead>
              <tr>
                <th>Course</th>
                <th>Duration</th>
              </tr>
            </thead>
            <tbody>
              {program.courses.map(({ course, duration, badge }, i) => (
                <tr key={i}>
                  <td>
                    {course}
                    <br />
                    {badge && <strong className="pm-badge">{badge}</strong>}
                  </td>
                  <td className="pm-duration">{duration}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="pm-apply-footer">
          <button className="pm-apply-btn" onClick={handleApply}>
            Apply Now
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

const Overview = ({ onApplyNow }) => {
  const [selected, setSelected] = useState(null);

  return (
    <section className="ov-root">
      <div className="ov-inner">

        {/* ── Our Mission ── */}
        <div className="ov-block">
          <span className="ov-eyebrow">Our Mission</span>
          <p className="ov-mission-text">
            To empower universities to deliver industry-relevant education through
            integrated academic programs — equipping students with knowledge, skills,
            and practical experience for successful careers.
          </p>
        </div>

        {/* ── What We Do ── */}
        <div className="ov-block">
          <span className="ov-eyebrow">What We Do</span>
          <div className="ov-grid">
            {WHAT_WE_DO.map(({ num, title, desc }) => (
              <div key={num} className="ov-card">
                <span className="ov-card-num">{num}</span>
                <strong className="ov-card-title">{title}</strong>
                <p className="ov-card-desc">{desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* ── Academic Programs ── */}
        <div className="ov-block ov-block--programs">
          <span className="ov-eyebrow">Academic Programs</span>
          <div className="ov-tags">
            {PROGRAMS.map((p) => (
              <button key={p.label} className="ov-tag" onClick={() => setSelected(p)}>
                {p.label}
              </button>
            ))}
          </div>
        </div>

      </div>

      {selected && (
        <ProgramModal program={selected} onClose={() => setSelected(null)} onApplyNow={onApplyNow} />
      )}
    </section>
  );
};

export default Overview;
